// extracted by mini-css-extract-plugin
export var select = "_oq-0";